let home = [
    {
        path: "/home",
        component: () => import("@/views/home/home.vue"),
    },{
        path: "/invoiceClip",
        component: () => import("@/views/invoiceClip/invoiceClip.vue"),
        meta: {
            title:"发票夹"
        },
    },{
        path: "/jobNavigation",
        component: () => import("@/views/jobNavigation/jobNavigation.vue"),
        meta: {
            title:"工作流导航",
            keepAlive:true
        },
    },{
        path: "/setting",
        component: () => import("@/views/setting/index.vue"),
        meta: {
            title:"设置",
            keepAlive:true
        },
    },{
        path: "/myRequest",
        component: () => import("@/views/myItems/myRequest.vue"),
        meta: {
            title:"我的请求"
        },
    },{
        path: "/myBacklog",
        component: () => import("@/views/myItems/myBacklog.vue"),
        meta: {
            title:"共享审核",
            type:"approve"
        },
    },{
        path: "/receiptApproval",
        component: () => import("@/views/myItems/myBacklog.vue"),
        meta: {
            title:"属地审核",
            type:"receiptApproval"
        },
    },{
        path: "/myHaveDone",
        component: () => import("@/views/myItems/myHaveDone.vue"),
        meta: {
            title:"我的已办"
        },
    }
    ,{
        path: "/wxTest",
        component: () => import("@/views/myItems/wxTest.vue"),
        meta: {
            title:"微信测试"
        },
    },
    {
        path: "/no404",
        component: () => import("@/views/n404/no404.vue"),
    }
]

export default home